angular.module('routes.simulation.SimulationPayloadResolver', [
  'stack'
])

/**
 * The SimulationPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class SimulationPayloadResolver
 * @constructor
 * @module routes.simulation.SimulationPayloadResolver
 */
.factory('SimulationPayloadResolver', [
  '$rootScope',
  'GLOBAL',
  'ModelsService',
  function ($rootScope, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      var result;
      var report;
      var endpoint;

      return ModelsService
        .get('cases', GLOBAL.apiPath + '/cases', { id: params.caseId })
        .then(function (response) {
          $rootScope.simulation = response;
          $rootScope.simulation.content.initialized = false;

          if (!$rootScope.report && params.caseId) {
            report = {
              label: 'report-' + uuid.v1(),
              content: {
                simulation: {
                  id: params.caseId,
                  group: $rootScope.simulation.content.group,
                  theme: $rootScope.simulation.content.theme,
                  title: response.label
                },
                timing: {
                  start: new Date().toISOString(),
                  end: null
                },
                user: $rootScope.user,
                events: []
              }
            };

            // create report
            endpoint = ModelsService.find('endpoints', 'label', 'reports');

            result = ModelsService
            .create(endpoint, report)
            .then(function (newReportResponse) {
              $rootScope.report = newReportResponse;
              return newReportResponse;
            });
          } else {
            result = {};
          }

          return result;
        });
    };
  }
]);
